import { useForm } from '@inertiajs/react'
import Seo from '../../components/Seo'
import { useShared } from '../../lib/hooks'

export default function ResetPassword({ reset_password_token }: { reset_password_token: string }) {
  const { errors } = useShared()
  const form = useForm({
    user: { password: '', password_confirmation: '', reset_password_token },
  })

  function submit(e: React.FormEvent) {
    e.preventDefault()
    form.put('/password')
  }

  return (
    <>
      <Seo title="Set a new password" noindex />
      <div className="mx-auto max-w-md px-4 sm:px-6 py-16">
        <div className="mono-label mb-3">Account</div>
        <h1 className="text-3xl font-semibold tracking-tight">Set a new password</h1>
        <p className="mt-2 text-muted text-sm">Choose a new password for your account.</p>

        {errors?.password && (
          <div className="mt-6 rounded-md border border-red-500/40 bg-red-500/10 text-red-300 px-4 py-2.5 text-sm">
            {errors.password}
          </div>
        )}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="mono-label">New password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={6}
              value={form.data.user.password}
              onChange={(e) => form.setData('user', { ...form.data.user, password: e.target.value })}
              className="mt-1.5 w-full h-12 bg-ink-soft border border-line focus:border-paper outline-none px-3.5 text-paper transition-colors"
            />
          </label>
          <label className="block">
            <span className="mono-label">Confirm new password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={6}
              value={form.data.user.password_confirmation}
              onChange={(e) =>
                form.setData('user', { ...form.data.user, password_confirmation: e.target.value })
              }
              className="mt-1.5 w-full h-12 bg-ink-soft border border-line focus:border-paper outline-none px-3.5 text-paper transition-colors"
            />
          </label>

          <button
            type="submit"
            disabled={form.processing}
            className="w-full h-12 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {form.processing ? 'Saving…' : 'Save new password'}
          </button>
        </form>
      </div>
    </>
  )
}
